import { useState } from 'react';
import { ArrowRight } from 'lucide-react';

import { content, projectsPl, projectsEn } from '../../data';

import './ProjectList.css';

const ProjectList = ({ setView, lang }) => {
  const t = content[lang].work;

  const latestProjects = lang === 'en' ? projectsEn : projectsPl;
  
  const [activeImg, setActiveImg] = useState(null);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  
  const handleMouseMove = (e) => {
    setMousePos({ x: e.clientX, y: e.clientY });
  };

  return (
    <section id="work" className="work-section" onMouseMove={handleMouseMove}>
      <div 
        className="floating-preview"
        style={{ 
          opacity: activeImg ? 1 : 0,
          left: mousePos.x + 0 + "px",
          top: mousePos.y,
        }}
      >
        {activeImg && (
          <img src={activeImg} alt="Project Preview" />
        )}
      </div>

      <div className="container">
        <div className="section-header">
          <span>{t.header}</span>
          <span>{t.dateRange}</span>
        </div>

        <div className="project-list">
          {latestProjects.map((project) => (
            <div 
              key={project.id}
              className="project-item"
              onMouseEnter={() => setActiveImg(project.image)}
              onMouseLeave={() => setActiveImg(null)}
            >
              <h2 className="project-title">
                {project.title}
              </h2>
              <span className="project-category">
                {project.category}
              </span>
            </div>
          ))}
        </div>

        <div className="archive-link-container">
          <button 
            onClick={() => { setView('archive'); window.scrollTo(0,0); }}
            className="archive-link"
          >
            {t.archiveLink} 
            <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProjectList;